import React, { useEffect, useState } from 'react';

import PurchaseGlasses from '../../../components/purchaseGlasses';
import { CommerceService } from '../../../services/commerceService';
import * as Edge from '../../../core';
import { CheckoutSession } from '../index';

interface GlassesOptionProps {
	checkout: CheckoutSession;
	isRecurring: boolean;
	productRenewalMonths?: number;
	setError: React.Dispatch<React.SetStateAction<Edge.Models.EdgeError | undefined>>;
	updateGlassesQuantity: (glassesQuantity: number) => void;
}

export default function GlassesOption(props: GlassesOptionProps) {
	const [url, setUrl] = useState<string>();

	const { checkout, isRecurring, productRenewalMonths, setError, updateGlassesQuantity } = props;

	useEffect(() => {
		if (url) {
			window.location.href = url;
		}
	}, [url]);

	return (
		<PurchaseGlasses
			showRecurringSubscriptionFields={isRecurring}
			onSubmit={async (values) => {
				try {
					const checkoutSession = await CommerceService.createCheckoutSession({
						cancelUrl: checkout.cancelUrl,
						checkoutSessionType: checkout.checkoutSessionType,
						country: values.country,
						email: checkout.email,
						entityId: checkout.entityId,
						entityType: checkout.entityType,
						glassesQuantity: parseInt(values.glassesNumber, 10),
						mode: checkout.mode,
						name: checkout.name,
						organizationId: checkout.organizationId,
						price: checkout.price,
						quantity: checkout.quantity,
						sport: checkout.sport,
						successUrl: checkout.successUrl,
					});

					updateGlassesQuantity(parseInt(values.glassesNumber, 10));
					setUrl(checkoutSession.url);
				} catch (e) {
					setError(e as Edge.Models.EdgeError);
				}
			}}
			productRenewalMonths={productRenewalMonths}
		/>
	);
}
